import { lazyRouteComponent } from "@tanstack/react-router";
import { UserRound } from "lucide-react";

import type { PageDef } from "@/app/registry";

export const pages: PageDef[] = [
  {
    path: "/app/account",
    title: "Account",
    component: lazyRouteComponent(() => import("./AccountPage"), "AccountPage"),
    nav: { label: "Account", icon: UserRound, group: "System", order: 90 },
    employees: true, // V036 staff keep their account page
  },
];
